// extracted by mini-css-extract-plugin
module.exports = {"noItemsAddNewCalculationButton":"CalculatedVariablesTable_noItemsAddNewCalculationButton__1q0Bx"};